import React from 'react';
import Page from '../../Components/Page';
import './style.scss';

function History() {
  return <Page title='History'>NO DATA</Page>;
}

export default History;
